import { InputGroup, Intent } from '@blueprintjs/core';
import { TFunction } from 'i18next';
import * as React from 'react';
import { Field } from 'react-final-form';

import useClientTranslations from '../../../../hooks/useClientTranslations';
import { TractableFormGroup } from './Shared';

const required = (field: string, t: TFunction) => (value: any) => {
	if (!value) {
		return t('{{field}} is required', { field });
	}

	return undefined;
};

const Make: React.FC = () => {
	const { t } = useClientTranslations();

	return (
		<Field name="make" validate={required(t('Make'), t)}>
			{({ input, meta }) => (
				<TractableFormGroup
					label={t('Make')}
					inline
					intent={Intent.DANGER}
					helperText={
						meta.invalid && meta.touched && (t(meta.error) || (!meta.dirtySinceLastSubmit && t(meta.submitError)))
					}
				>
					<InputGroup {...input} placeholder="ex: Ford" />
				</TractableFormGroup>
			)}
		</Field>
	);
};

export { Make };
